import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';

@Component({
    selector: `
        a[nw-link],span[nw-link]
      `,
    template: `<ng-content></ng-content>`,
    styleUrl: 'link.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.disabled]': '_getDisabledAttribute()',
        '[class.nw-link]': 'true',
        '[class.nw-link--disabled]': '_getDisabledAttribute()'
    }
})
export class LinkComponent {
    @Input({ transform: booleanAttribute })
    get disabled(): boolean {
        return this._disabled;
    }
    set disabled(value: any) {
        this._disabled = value;
    }
    private _disabled: boolean = false;

    public _getDisabledAttribute() {
        return !this.disabled ? null : true;
    }
}
